import { ButtonPrimary } from '../../../../../components/ButtonPrimary';
import { TableHeading } from '../../../../../components/TableHeading';
import styles from './NetworkPricesResultBar.module.scss';

type NetworkPricesResultBarProps = {
  total: number;
  selectedCount: number;
  canApply: boolean;
  isApplying: boolean;
  onApply: () => void;
};

export const NetworkPricesResultBar = ({ total, selectedCount, canApply, isApplying, onApply }: NetworkPricesResultBarProps) => (
  <TableHeading isSelected={selectedCount > 0}>
    <TableHeading.TotalProducts total={selectedCount || total} className={styles.total} />
    <ButtonPrimary disabled={!canApply} isLoading={isApplying} onClick={onApply}>
      Aplicar preço
    </ButtonPrimary>
  </TableHeading>
);
